import '../../styles/global.scss';
import 'fontsource-noto-sans-kr';
import 'bootstrap/dist/css/bootstrap.min.css';
import styled from 'styled-components';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import React from 'react';

import logo from '../../images/logo-footer.png';

const FooterWrapper = styled.footer`
  width: 100%;
  background: #3d3d3d;
  font-size: 0.875rem;
  font-family: 'Noto Sans KR', sans-serif;
  font-weight: 400;
  z-index: 9;
  color: #b9b9b9;

  h1 > img {
    width: 140px;
    vertical-align: super;
  }

  .title {
    margin-top: 0.5rem;
    font-size: 0.875rem;
    font-weight: 500;
  }

  .gray-text {
    color: #7d7d7d;
  }

  .hr-short-line {
    width: 30px;
    height: 2px;
  }

  .fz-13 {
    font-size: 0.813rem;
  }

  a {
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const Footer = () => {
  return (
    <FooterWrapper className="border-top">
      <Container className="pt-5 pb-4 row mx-auto">
        <Row>
          <Col lg={4}>
            <h1>
              <img src={logo} alt="한국직업개발원 로고" />
            </h1>
            <div>
              <p className="mb-2 gray-text">(주)에이치알디한국중소기업교육원</p>
              <p className="mb-2 gray-text">대표이사 : 한종률</p>
              <p className="mb-2 gray-text">사업자등록번호 : 675-86-00074</p>
              <p className="mb-2 gray-text">
                주소 : 서울특별시 성동구 상원12길 30
                <br />
                동진IT타워 11층 1101호~1102호
              </p>
            </div>
            <div>
              <p className="mb-2 gray-text">
                개인정보관리책임자 : 최종근
                <br />
                (hrdcenter@hrdcenter.co.kr)
              </p>
            </div>
            <hr className="d-block d-lg-none" />
          </Col>

          <Col lg={4}>
            <h2 className="title mb-3 mb-lg-2">입금계좌안내</h2>
            <hr className="hr-short-line d-none d-lg-block" />
            <div>
              <p className="mb-1">예금주</p>
              <p className="mb-3 text-white">(주)에이치알디한국중소기업교육원</p>
              <p className="mb-1">스탠다드차타드은행</p>
              <p className="mb-3 text-white">379-20-234800</p>
              <p className="mb-1">국민은행</p>
              <p className="text-white">437601-01-406983</p>
            </div>
            <hr className="d-block d-lg-none" />
          </Col>

          <Col lg={4}>
            <h2 className="title mb-3 mb-lg-2">고객센터</h2>
            <hr className="hr-short-line d-none d-lg-block" />
            <div>
              <p className="mb-2 text-white">
                Tel : 02-525-7107 | Fax : 02-512-8530
              </p>
              <p className="mb-1 text-white">업무시간 : 평일 9:30 ~ 18:00</p>
              <p className="fz-13">(점심시간 12:30 ~ 13:30 제외)</p>
              <p className="gray-text fz-13">
                업무시간 이외 상담은 상담톡을 통해 문의하여 주십시오
              </p>
            </div>
            <hr className="d-block d-lg-none" />
            <hr className="hr-short-line d-none d-lg-block" />
            <p className="mb-1">
              <a className="text-white fz-13" href="https://notice.hrdcen.com/tos" target="_blank" rel="noopener noreferrer">
                이용약관
              </a>
            </p>
            <p>
              <a className="text-white fz-13" href="https://notice.hrdcen.com/privacy" target="_blank" rel="noopener noreferrer">
                개인정보처리방침
              </a>
            </p>
          </Col>
        </Row>
        <p className="gray-text text-center mt-5">
          &copy; 2021 HRDCenter All Rights Reserved
        </p>
      </Container>
    </FooterWrapper>
  );
};

export default Footer;
